import React, { ReactElement, ReactNode } from 'react';
import { Button } from 'react-bootstrap';
import { VscReplace, VscReplaceAll } from 'react-icons/all';
import PopoverSimple from '../../PopoverSimple';
import { BaseEntite, BaseEntiteSommaireStatique } from '../../../../../../common/src/entities';
import ApercuEntite from '../../ApercuEntite';

export interface PropsDeChamp<TEntite extends BaseEntite> {
    injectionTitle?: string;
    injectionTrace?: string;
    injectionPreview?: any | TEntite;
    injectionModel?: BaseEntiteSommaireStatique<TEntite>;
    groupInjection?: boolean;
    size?: 'sm' | 'lg';
    disabled?: boolean;
    onClick: () => void;
}

export default function InjectionButton<TEntite extends BaseEntite>(props: PropsDeChamp<TEntite>): ReactElement {
    const {
        injectionTitle,
        injectionTrace,
        injectionPreview,
        injectionModel,
        groupInjection,
        size,
        disabled,
        onClick,
    } = props;

    function ButtonIcon(props): ReactElement {
        return groupInjection ? <VscReplaceAll {...props} /> : <VscReplace {...props} />;
    }

    let injectionPreviewValue: string | ReactNode | undefined;

    if (injectionPreview) {
        injectionPreviewValue = !injectionModel ? (
            injectionPreview
        ) : (
            <ApercuEntite model={injectionModel as BaseEntiteSommaireStatique<TEntite>} entiteRef={injectionPreview} />
        );
    } else {
        injectionPreviewValue = (
            <i>
                {
                    'Injection de valeur impossible. Aucune valueur trouvé à partir de la référence attachée à ce champs. Veuillez entrer manuellement une valeur pour ce champs'
                }
            </i>
        );
    }

    const popoverContent: string | ReactNode | undefined = injectionPreviewValue ? (
        <>
            {injectionTrace}
            <br />
            <br />
            <strong>{'Aperçu:'}</strong>
            <br />
            &nbsp;{injectionPreviewValue}
        </>
    ) : (
        injectionTrace
    );

    const wrapperPointerEvents: 'auto' | 'none' = disabled ? 'auto' : 'none';
    const buttonPointerEvents: 'auto' | 'none' = disabled ? 'none' : 'auto';

    return (
        <PopoverSimple texte={popoverContent} titre={injectionTitle}>
            <div className="d-flex" style={{ pointerEvents: wrapperPointerEvents, zIndex: 0 }}>
                <Button
                    className="d-flex align-items-center"
                    style={{ pointerEvents: buttonPointerEvents }}
                    onClick={() => onClick()}
                    size={size || undefined}
                    disabled={disabled}
                >
                    <ButtonIcon size="1em" />
                </Button>
            </div>
        </PopoverSimple>
    );
}
